<template>
  <div />
</template>

<script>
// Custom types for the system
const MapMarkerTypes = {
  simple: 'simple',
  routeStart: 'routeStart',
  routeEnd: 'routeEnd',
  routeWaypoint: 'routeWaypoint',
  squarePin: 'squarePin',
  customPin: 'customPin',
}

export default {
  MapMarkerTypes: MapMarkerTypes,
  props: {
    google: {
      type: Object,
      required: true
    },
    map: {
      type: Object,
      required: true
    },
    position: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: MapMarkerTypes.simple
    },
    strokeColour: {
      type: String,
      default: '#ffffff'
    },
    fillColour: {
      type: String,
      default: '#000000'
    },
    labelColour: {
      type: String,
      default: '#000000'
    },
    title: String,
    label: String
  },
  data() {
    return {
      mapMarker: null,
      clickListener: null
    }
  },
  mounted() {
    var markerOptions = {
      position: this.position,
      title: this.title || '',
      label: this.label || '',
      map: this.map
    }

    if(this.type == MapMarkerTypes.routeStart || this.type == MapMarkerTypes.routeEnd) {
      markerOptions.icon = {
        path: this.google.maps.SymbolPath.CIRCLE,
        scale: 8,
        strokeWeight: 2,
        fillOpacity: 1,
        strokeColor: this.strokeColour,
        fillColor: this.fillColour
      }
    }
    if(this.type == MapMarkerTypes.routeWaypoint) {
      markerOptions.icon = {
        path: this.google.maps.SymbolPath.CIRCLE,
        scale: this.label ? 11 : 5,
        strokeWeight: 2,
        fillOpacity: 1,
        strokeColor: this.strokeColour,
        fillColor: this.fillColour
      }
    }
    if(this.type == MapMarkerTypes.squarePin) {
      markerOptions.icon = {
        path: 'M22-48h-44v43h16l6 5 6-5h16z',
        fillOpacity: 1,
        fillColor: this.fillColour,
        scale: 0.5,
        anchor: new this.google.maps.Point(0, 12),
        labelOrigin: new this.google.maps.Point(0, -25),
      }
      if(this.label) {
        markerOptions.label = {
          text: this.label,
          color: this.labelColour,
        }
      }
    }
    if(this.type == MapMarkerTypes.customPin) {
      markerOptions.icon = {
        path: 'M0-48c-9.8 0-17.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z',
        fillOpacity: 1,
        fillColor: this.fillColour,
        scale: 0.6,
        anchor: new this.google.maps.Point(0, 12),
        labelOrigin: new this.google.maps.Point(0, -25),
      }
      if(this.label) {
        markerOptions.label = {
          text: this.label,
          color: this.labelColour,
        }
      }
    }

    this.mapMarker = new this.google.maps.Marker(markerOptions)
    this.clickListener = this.mapMarker.addListener("click", (evt) => {
      this.$emit('click', evt)
    })
  },
  beforeDestroy() {
    if(this.clickListener)
      this.clickListener.remove()
    if(this.mapMarker)
      this.mapMarker.setMap(null)
  }
}
</script>